export type Role = "admin" | "operations" | "content";

export function hasPermission(userRoles: Role[], requiredRole: Role) : boolean {
    if (userRoles.includes("admin")) {
        return true;
    }

    return userRoles.includes(requiredRole);
}